import { render, staticRenderFns } from "./InlineLink.vue?vue&type=template&id=af2af70c&scoped=true&"
import script from "./InlineLink.vue?vue&type=script&lang=js&"
export * from "./InlineLink.vue?vue&type=script&lang=js&"
import style0 from "./InlineLink.vue?vue&type=style&index=0&id=af2af70c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af2af70c",
  null
  
)

export default component.exports